const SHOW_UNREAD_LEADS_MODAL = 'avisos/unreadLeadsMsg/SHOW_UNREAD_LEAD_MODAL';
const SEND_UNREAD_LEADS_MSG = 'avisos/unreadLeadsMsg/SEND_UNREAD_LEAD_MSG';
const SEND_UNREAD_LEADS_MSG_COMPLETED = 'avisos/unreadLeadsMsg/SEND_UNREAD_LEAD_MSG_COMPLETED';
const SEND_UNREAD_LEADS_MSG_FAILED = 'avisos/unreadLeadsMsg/SEND_UNREAD_LEAD_MSG_FAILED';
const HAS_UNREAD_LEADS = 'avisos/unreadLeadsMsg/HAS_UNREAD_LEADS';
const HAS_UNREAD_LEADS_COMPLETED = 'avisos/unreadLeadsMsg/HAS_UNREAD_LEADS_COMPLETED';
const HAS_UNREAD_LEADS_FAILED = 'avisos/unreadLeadsMsg/HAS_UNREAD_LEADS_FAILED';
const RESET_UNREAD_LEADS = 'avisos/unreadLeadsMsg/RESET_UNREAD_LEADS';

export {
  SHOW_UNREAD_LEADS_MODAL,
  SEND_UNREAD_LEADS_MSG,
  SEND_UNREAD_LEADS_MSG_COMPLETED,
  SEND_UNREAD_LEADS_MSG_FAILED,
  HAS_UNREAD_LEADS,
  HAS_UNREAD_LEADS_COMPLETED,
  HAS_UNREAD_LEADS_FAILED,
  RESET_UNREAD_LEADS
};
